import { apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

export const complianceApi = {
  createAlert: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/compliance/alerts`, body),

  listAlerts: (params?: PaginatedParams & { jurisdiction?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.jurisdiction) searchParams.set("jurisdiction", params.jurisdiction);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/compliance/alerts?${searchParams.toString()}`);
  },

  getAlert: (id: string) => apiGet<{ data: Record<string, unknown> }>(`/compliance/alerts/${id}`),

  dismissAlert: (id: string) => apiPost<{ data: Record<string, unknown> }>(`/compliance/alerts/${id}/dismiss`),

  listMyAlerts: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/compliance/my-alerts?${searchParams.toString()}`);
  },

  reportContent: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/compliance/reports`, body),

  listReports: (params?: PaginatedParams & { status?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.status) searchParams.set("status", params.status);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/compliance/reports?${searchParams.toString()}`);
  },

  moderateContent: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(`/compliance/moderate`, body),

  listModerationActions: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`/compliance/moderation-actions?${searchParams.toString()}`);
  },

  bulkDeleteAlerts: (ids: string[]) => apiDelete<{ data: number }>(`/compliance/alerts/bulk-delete`, { data: { ids } }),

  bulkDeleteReports: (ids: string[]) => apiDelete<{ data: number }>(`/compliance/reports/bulk-delete`, { data: { ids } }),

  bulkDeleteModerationActions: (ids: string[]) => apiDelete<{ data: number }>(`/compliance/moderation-actions/bulk-delete`, { data: { ids } }),

  getStats: () => apiGet<{ data: Record<string, unknown> }>(`/compliance/compliance/stats`),

  export: (type = "alerts", format = "CSV") => apiGet<{ data: unknown }>(`/compliance/compliance/export?type=${type}&format=${format}`),
};